// extracted by mini-css-extract-plugin
module.exports = {"main":"label-field_main__23Rkj","label":"label-field_label__314yO","text":"label-field_text__2nrVM"};